import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { Tooltip } from 'radix-ui';

/** Texts the components show by themselves, in the person's language (the app translates them). */
export interface UILabels {
  /** The close button of a dialog. */
  close: string;
}

const DEFAULT_LABELS: UILabels = { close: 'Close' };
const Labels = createContext<UILabels>(DEFAULT_LABELS);

/** Wraps the app once: labels for the components, and the timing of tooltips. */
export function UIProvider({ labels, children }: { labels?: Partial<UILabels>; children: ReactNode }) {
  const close = labels?.close;
  const value = useMemo(() => ({ ...DEFAULT_LABELS, ...(close ? { close } : {}) }), [close]);
  return (
    <Labels.Provider value={value}>
      <Tooltip.Provider delayDuration={350} skipDelayDuration={200}>
        {children}
      </Tooltip.Provider>
    </Labels.Provider>
  );
}

export function useLabels(): UILabels {
  return useContext(Labels);
}
